import React from "react";
import RightTop from "./right-top";
import RightBottom from "./right-bottom";

const Right = () => {
    return (
        <div className="col-11 col-lg-8 second-col">
            <div className="row align-items-center justify-content-center">
                <div className="col-11">
                    <h3>Seyed Mohamad Hasan Mahmodian</h3>
                    <p className="text-secondary mt-1">AKA Kneonix</p>
                </div>
                <RightTop />
                
                <RightBottom />
            </div>
        </div>
    );
};

export default Right;
